<template>
    <div class="home">
        <div class="navigation-bar-left">
            <div class="logo-container">
                <!--                <div class="logo-icon">-->
                <!--                    <i class="gf gf-gekko-logo"></i>-->
                <!--                </div>-->
                <!--                <div class="logo-text">-->
                <!--                    <span>DocAnalyzer</span>-->
                <!--                </div>-->
                <div class="text-logo">DocAnalyzer</div>
            </div>
            <div class="main-body">
                <div class="tabs-bar">
                    <ul class="list">
                        <li v-for="(item,index) in shownTabs" :key="index" class="no-sublist"
                            :class="{active: activeTabId===item.tabId}">
                            <div class="button" @click="setActiveTabId(item.tabId)">
                                <div class="button-content d-flex align-items-center"><i
                                        :class="item.tabLabelIconClass"></i><span>{{item.tabLabelText}}</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="home-main-content">
            <div class="toolbox">
                <work-mode-switch></work-mode-switch>
                <account-button v-if="userInfo" :user-info="userInfo"></account-button>
            </div>
            <div class="home-tab-content">
                <component v-for="(item,index) in shownTabs" :key="index" :is="item.tabComponent"
                           v-show="activeTabId===item.tabId"></component>
            </div>
        </div>
    </div>
</template>

<script>
    import HomeProjects from "@/components/HomeProjects";
    import SimpleDropdown from "@/components/SimpleDropdown";
    import HomeUserManager from "@/components/HomeUserManager";
    import HomeProductivity from "@/components/HomeProductivity";
    import AccountButton from "@/components/AccountButton";
    import SettingsButton from "@/components/SettingsButton";
    import WorkModeSwitch from "@/components/WorkModeSwitch";

    const projectsTabId = 'projects';
    const userManagerTabId = 'usermanager';
    const productivityTabId = 'productivity';

    export default {
        name: "Home",
        components: {WorkModeSwitch, SettingsButton, AccountButton, HomeUserManager, SimpleDropdown, HomeProjects},
        data() {
            return {
                projectsTabId: projectsTabId,
                userManagerTabId: userManagerTabId,
                fullTabs: [
                    {
                        tabId: projectsTabId,
                        managerOnly: false,
                        tabLabelIconClass: 'gf gf-project',
                        tabLabelText: 'All Projects',
                        tabComponent: HomeProjects,
                    },
                    {
                        tabId: productivityTabId,
                        managerOnly: true,
                        tabLabelIconClass: 'gf gf-productivity smaller',
                        tabLabelText: 'Productivity',
                        tabComponent: HomeProductivity,
                    },
                    {
                        tabId: userManagerTabId,
                        managerOnly: true,
                        tabLabelIconClass: 'gf gf-user-manager smaller',
                        tabLabelText: 'User Manager',
                        tabComponent: HomeUserManager,
                    },
                ]
            }
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo
            },
            activeTabId() {
                let tab = this.$route.query.tab;
                if (this.shownTabIds.indexOf(tab) !== -1) {
                    return tab;
                }
                return projectsTabId;
            },
            isUserManager() {
                return this.$store.state.isUserManager;
            },
            shownTabs() {
                const {isUserManager} = this;
                return this.fullTabs.filter(v => (v.managerOnly ? isUserManager : true));
            },
            shownTabIds() {
                return this.shownTabs.map(v => (v.tabId));
            }
        },
        methods: {
            logout() {
                this.eventHub.$emit('doLogout');
            },
            setActiveTabId(tabId) {
                if (tabId === this.activeTabId) {
                    return;
                }
                this.$router.push({name: 'home', query: {tab: tabId}})
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/variables";

    .home {
        height: 100%;
        display: flex;
    }

    .navigation-bar-left {
        min-width: 240px;
        width: 18%;
        height: 100%;
        background-color: white;
        border-right: 1px solid #e0e0e0;

        .logo-container {
            text-align: center;
            padding: 1.5rem 0 0;
            margin-bottom: 1.5rem;

            .logo-icon {
                font-size: 4rem;
                display: inline-block;
                color: $primary-purple;
            }

            .logo-text {
                font-size: 1.32rem;
                font-weight: 500;
                margin-top: -1rem;
            }

            .text-logo {
                font-size: 2.0rem;
                font-family: 'Hammersmith One', sans-serif;
                //background-color: #111111;
                //color: white;
                //font-size: 18px;
                //border-radius: 4px;
                //letter-spacing: 1px;
                //user-select: none;
                //display: inline-flex;
                //width: 42px;
                //height: 40px;
                //font-weight: 500;
                //align-items: center;
                //justify-content: center;
            }
        }

        .tabs-bar {
            .button {
                font-size: 1rem;
                font-weight: 500;
                height: 4.2rem;

                .smaller {
                    font-size: 1.25em;
                }

                i.gf {
                    min-width: 24px;
                }
            }
        }
    }

    .home-main-content {
        height: 100%;
        flex: 1 1 auto;
        width: 82%;
        //background-color: white;

        .toolbox {
            position: absolute;
            top: 0;
            right: 2rem;
            height: 90px;
            display: flex;
            align-items: center;
            z-index: 2;

            & > *:not(:last-child) {
                margin-right: 0.8rem;
            }
        }

        .home-tab-content {
            width: 100%;
            height: 100%;
            overflow: auto;
        }
    }
</style>
